// The public moderation queue lives at a non-obvious path on purpose. Access
// is still decided server-side (the backend's moderator check on every call),
// the page is noindex, and it is NOT listed in robots.txt (a Disallow line
// would advertise it). Moderators reach it from the account menu.
export const MOD_PATH = "/floor-ops-7k3f";
